module.exports = __webpack_public_path__ + "static/media/leaf.7c6a9cf3.svg";